<template>
  <div>
    <div class="flex justify-between">
      <label
        v-if="label"
        :for="label"
        class="text-light block text-xs font-medium"
        >{{ label }}</label
      >
      <span v-if="optional" class="text-sm text-gray-400">{{ optional }}</span>
    </div>
    <div class="relative mt-1 rounded-md shadow-sm">
      <div
        v-if="trailing"
        class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
      >
        <span class="text-gray-400 sm:text-sm">
          {{ trailing }}
        </span>
      </div>
      <input
        :type="type"
        :value="value"
        @input="updateValue"
        @change="updateValue"
        @blur="$emit('blur')"
        :disabled="disabled"
        :class="[
          error ? ' border-red-300 text-red-900 ' : 'border border-gray-400',
          trailing ? 'px-8 ' : 'px-4',
        ]"
        class="bg-ontick-title text-ontick-card-title input_form focus:outline-none block block h-12 w-full w-full appearance-none rounded-md py-2 focus:border-red-500 sm:text-sm"
        :placeholder="placeholder"
      />
      <div
        v-show="error"
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
      >
        <!-- Heroicon name: exclamation-circle -->
        <svg
          class="h-5 w-5 text-red-500"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
    </div>
    <p v-show="error" class="mt-2 text-sm text-red-600">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: "ontick_input_large",

  $_veeValidate: {
    name() {
      return this.label;
    },
    value() {
      return this.value;
    },
  },
  props: {
    value: String,

    label: {
      type: String,
    },
    placeholder: {
      type: String,
      default: "",
    },
    optional: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    trailing: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      default: "text",
      validator: (val) => {
        return (
          ["url", "text", "password", "email", "search"].indexOf(val) !== -1
        );
      },
    },
  },
  methods: {
    updateValue(e) {
      this.$emit("input", e.target.value);
    },
  },
};
</script>
<style></style>
